module.exports = __webpack_public_path__ + "static/microsoft-planner-1ec9015cbfb0479d66890591da200d51.svg";